import React from "react";
import HomePortfolio from "./Portfolio";
import UsHome from "./Whyus";
import TechStackCitations from "./TechStackCitations";
import useSEO from "./useSEO";

const PortfolioPage = () => {
  useSEO({
    title: "Client Case Studies & Portfolio | Shopify Stores, Mobile Apps & SaaS MVPs",
    description: "Explore deployed engineering case studies: custom high-converting Shopify 2.0 storefronts, Flutter mobile apps, SaaS MVPs, and intelligent AI workflow automations.",
    keywords: "shopify portfolio, ecommerce case studies, custom shopify stores showcase, flutter mobile app portfolio, react native apps showcase, saas mvp portfolio, ai workflow automation case studies, ai voice calling agent demo, core spectators portfolio",
    canonical: "https://corespectators.com/Portfolio",
    schema: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Core Spectators Client Portfolio & Engineering Case Studies",
      "url": "https://corespectators.com/Portfolio",
      "description": "Featured deployed case studies across bespoke Shopify 2.0 storefronts, cross-platform mobile apps, SaaS platforms, and intelligent AI workflow automations.",
      "about": [
        "Custom Shopify 2.0 Store Development",
        "Mobile App Development (Flutter & React Native)",
        "Custom SaaS Platform Engineering",
        "AI Workflow Automation & Voice Telephony Agents"
      ]
    }
  });

  return (
    <>
      <HomePortfolio />
      <TechStackCitations />
      <UsHome />
    </>
  );
};

export default PortfolioPage;